import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';

function ComprehensiveeCTDSPLPublishingServices() {

  return (
    <div className="font-sans ">
      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'Regulatory Services', 'Comprehensive eCTD & SPL Publishing Services']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

         <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Regulatory Services
        </h2>

        <div className="flex items-center gap-2 mb-4 mt-12">
          <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-semibold text-[#05326D]">
            Comprehensive eCTD & SPL Publishing Services
          </h3>
        </div>

        <h4 className="text-md font-semibold text-[#05326D] mb-4">
          Your Trusted Partner for Global Regulatory Submissions
        </h4>

        <p className="mb-14 text-[#05326D]">
          <span className="text-md font-semibold text-[#05326D] mb-4">The Electronic Common Technical Document (eCTD)
          </span>
          is the internationally recognized standard for submitting
          regulatory information across global health authorities. With its XML backbone and structured format, eCTD
          enables seamless review and navigation of applications, amendments, supplements, variations, and reports by
          agencies such as:
        </p>

        <hr className="border-t border-gray-300 mb-12" />

         <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Our approach to regulatory strategy is built on six critical pillars:
        </h2>


        <div className="flex items-center gap-2 mb-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-semibold text-[#05326D]">
            US FDA (CDER & CBER)
          </span>
        </div>

        <div className="flex items-center gap-2 mb-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-semibold text-[#05326D]">
            European Medicines Agency (EMA)
          </span>
        </div>

        <div className="flex items-center gap-2 mb-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-semibold text-[#05326D]">
            Health Canada
          </span>
        </div>

        <div className="flex items-center gap-2 mb-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-semibold text-[#05326D]">
            GCC Authorities
          </span>
        </div>

        <div className="flex items-center gap-2 mb-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-semibold text-[#05326D]">
            TGA (Australia), MCC (South Africa), Thailand (ASEAN)
          </span>
        </div>
        <p className='text-[#05326D]'> …and many more. While several regions—including China—are still transitioning to eCTD formats, FDAC remains
          at the forefront of regulatory publishing innovation.</p>

        <hr className="border-t border-gray-300 my-10" />

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          End-to-End eCTD Publishing & Submission Support
        </h2>

        <div className="flex items-center gap-2 mb-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-semibold text-[#05326D]">
            Core eCTD Services
          </span>
        </div>
        <p className='ml-4 text-[#05326D] mb-1'>- eCTD Compilation, QC Review, Technical Validation & Hosting </p>
        <p className='ml-4 text-[#05326D] mb-1'>- Baseline eCTD Conversion (Paper/CTD/NeeS to eCTD) </p>
        <p className='ml-4 text-[#05326D] mb-1'>- Importing & Cloning of Existing Applications </p>
        <p className='ml-4 text-[#05326D] mb-1'>- Lifecycle Management: Amendments, Annual Updates, Query Responses, Post-Approval Changes</p>


        <div className="flex items-center gap-2 mb-4 mt-6">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-semibold text-[#05326D]">
            US FDA Submissions
          </span>
        </div>
        <p className='ml-4 text-[#05326D] mb-1'>-  ANDA Dossiers (Modules 1–5) </p>
        <p className='ml-4 text-[#05326D] mb-1'>- 505(j), 505(b)(1), 505(b)(2) Applications </p>
        <p className='ml-4 text-[#05326D] mb-1'>- SPL & SANDAs </p>
        <p className='ml-4 text-[#05326D] mb-1'>- DMF Publishing</p>
        <p className='ml-8 text-[#05326D] mb-1'>- Type II – APIs, Intermediates, Semi-Finished Formulations </p>
        <p className='ml-8 text-[#05326D] mb-1'>- Type III – Packaging Materials </p>
        <p className='ml-8 text-[#05326D] mb-1'>- Type IV – Excipients </p>
        <p className='ml-4 text-[#05326D] mb-1'>-  Post-Approval Changes:</p>
        <p className='ml-8 text-[#05326D] mb-1'>- CBE-0, CBE-30, Prior Approval Supplements (PAS):</p>



        <div className="flex items-center gap-2 mb-4 mt-6">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-semibold text-[#05326D]">
            European Union Submissions
          </span>
        </div>
        <p className='ml-4 text-[#05326D] mb-1'>- MAA Dossiers via: </p>
        <p className='ml-8 text-[#05326D] mb-1'>- National Procedure</p>
        <p className='ml-8 text-[#05326D] mb-1'>- Mutual Recognition Procedure (MRP)</p>
        <p className='ml-8 text-[#05326D] mb-1'>- Decentralized Procedure (DCP) </p>
        <p className='ml-4 text-[#05326D] mb-1'>- DMF/ASMF Publishing (Modules 1–3) </p>
        <p className='ml-4 text-[#05326D] mb-1'>- CEP Submissions via EDQM </p>
        <p className='ml-4 text-[#05326D] mb-1'>- Lifecycle Management: </p>
        <p className='ml-8 text-[#05326D] mb-1'>- Renewals, Variations (Type IA, IB, II, IAIN), Query Responses</p>

        <div className="flex items-center gap-2 mb-4 mt-6">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-semibold text-[#05326D]">
            Global Markets: GCC, Canada, Australia, South Africa, ASEAN, China
          </span>
        </div>
        <p className='ml-4 text-[#05326D] mb-1'>- Dossiers & DMFs </p>
        <p className='ml-4 text-[#05326D] mb-1'>- Baseline Publishing </p>
        <p className='ml-4 text-[#05326D] mb-1'>- Renewals, Variations, Query Responses </p>
        <p className='ml-4 text-[#05326D] mb-1'>- NeeS (Non-eCTD Electronic Submissions) for DMFs and Dossiers</p>
        <p className='ml-4 text-[#05326D] mb-1'>- China DMF Support</p>


        <hr className="border-t border-gray-300 my-10" />

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          PDF Publishing & Technical Enhancements
        </h2>
        <div className="flex items-center gap-2 mb-4 mt-6">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-semibold text-[#05326D]">
            Submission-Ready PDFs
          </span>
        </div>
        <div className="flex items-center gap-2 mb-4 mt-6">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-semibold text-[#05326D]">
            Bookmarking & Hyperlinking
          </span>
        </div>
        <div className="flex items-center gap-2 mb-4 mt-6">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-semibold text-[#05326D]">
            OCR (Optical Character Recognition)
          </span>
        </div> <div className="flex items-center gap-2 mb-4 mt-6">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-semibold text-[#05326D]">
            Embedded Fonts & Format Compliance
          </span>
        </div>
        <p className='ml-4 text-[#05326D] mb-1'> At FDAc, we combine regulatory intelligence with technical precision to deliver submission-ready dossiers that
          meet global standards. Whether you’re entering new markets or managing post-approval changes, our team
          ensures your documentation is accurate, compliant, and strategically positioned for success.</p>

      </div>
    </div>
  );
}

export default ComprehensiveeCTDSPLPublishingServices;
